<template>
  <div
    class="p-6 rounded-lg bg-cardColor border border-greenPrimary shadow-md transition duration-300"
    :class="[
      { 'hover:scale-105': scale },
      addClass,
      { 'bg-gray-300': selected },
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    scale: {
      type: Boolean,
      default: false,
    },
    addClass: [Array, String],
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
